<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="queryInfo.status" clearable style="width:180px">
          <el-option
          v-for="item in stateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="费用类型">
        <el-select
        v-model="queryInfo.feeType"
        filterable
        allow-create
        style="width:180px"
        clearable>
          <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="编号">
        <el-input v-model="queryInfo.eventId" clearable placeholder="请输入" style="width:180px"/>
      </el-form-item>
      <el-form-item label="情况说明">
        <el-input v-model="queryInfo.invoiceDescription" clearable placeholder="请输入" style="width:180px"/>
      </el-form-item>
      <el-form-item>
        <el-form-item label="付款状态">
        <el-select v-model="queryInfo.payStatus" clearable style="width:180px">
          <el-option
          v-for="item in payList"
          :key="item.label"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="add1('new')">申请</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="query">
        <el-tab-pane label="我的申请" name="queryMine"></el-tab-pane>
        <el-tab-pane label="待我审批" name="queryMyAudit">
          <div slot="label">
            待我审批
                <el-badge :value='workNumber' style="margin-bottom:20px"></el-badge>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已审批" name="queryApproval"></el-tab-pane>
    </el-tabs>
    <table-list
    :loading="loading || downloadLoading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    :tableRowClassName="tableRowClassName"
    >
    <template #operate={row}>
      <el-button type="text" size="small" v-if="row.status === 1 && activeName == 'queryMine' " @click="exportDetails(row)">导出审批单</el-button>
      <el-button type="text" size="small" v-if="row.status === 2 && activeName == 'queryMine' || row.status === 10 && activeName == 'queryMine'" @click="update(row.id)">修改</el-button> <!--1. 我的申请 待审核 -->
          <el-button type="text" size="small" @click="approval(row.id)" v-if="row.status === 0 && activeName == 'queryMine'">催批</el-button>
      <el-button type="text" size="small" @click="add(activeName === 'queryMine' ? 'details' : activeName === 'queryMyAudit' ? 'Approval' : 'details', row.id)">查看详情</el-button>
    </template>
    </table-list>
    <application ref="Application" @addSuccess="query"/>
    <download ref="Download"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import Download from './download.vue'
import Application from './application.vue'
import { queryMine, queryWaitMeProcess, listApplyAudited, sendSmsAuditPersonAgain, update } from '@/api/compApplyReimbursement'
import { ApprovalStatus, feeTypeList, payList } from '@/utils/constants'
export default {
  data () {
    return {
      activeName: 'queryMine',
      queryInfo: {
        status: '',
        feeType: '',
        payStatus: '',
        eventId: '',
        invoiceDescription: ''
      },
      typeList: feeTypeList,
      payList: payList,
      stateList: ApprovalStatus,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      workNumber: 0,
      tableData: [],
      loading: false,
      columnDefs: [
        { label: '编号', prop: 'eventId' },
        { label: '申请人', prop: 'applyUser', width: '80' },
        { label: '所属公司', prop: 'companyInfo.companyName', width: '180' },
        { label: '费用类型', width: '80', prop: 'feeType' },
        { label: '申请日期', prop: 'createTime' },
        {
          label: '审核人',
          width: '80',
          formatter: (row) => {
            return row.auditPerson || row.preAuditPerson
          }
        },
        { label: '审核状态',
          width: '80',
          prop: 'status',
          formatter: (row) => {
            let status = ApprovalStatus.find(item => item.value === row.status)
            return status?.label || ''
          }
        },
        { label: '付款状态',
          width: '80',
          formatter: (row) => {
            return row.payStatus ? '已付款' : '未付款'
          },
          prop: 'payStatus'
        },
        { label: '金额（元）', prop: 'feeAmount' },
        { label: '合同总金额', prop: 'contactTotalAmount', width: '100' },
        { label: '累计已付', prop: 'payedTotal', width: '80' },
        { label: '本次支付', prop: 'payedThisTime', width: '80' },
        { label: '剩余未付', prop: 'payedLeft', width: '80' },
        { label: '打印次数', prop: 'printTimes', width: '80' },
        { label: '情况说明', prop: 'invoiceDescription', width: '80' },
        { label: '操作', prop: 'operate', width: '150' }
      ],
      downloadLoading: false
    }
  },
  components: {
    TableList,
    Application,
    Download
  },
  methods: {
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      if (row.exportFlag && this.activeName === 'queryMine') {
          return 'export-row';
      }
        return '';
    },
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      let query = this.activeName === 'queryMine' ? queryMine : this.activeName === 'queryMyAudit' ? queryWaitMeProcess : listApplyAudited
      query({
        ...this.queryInfo,
        pageSize: this.pageSize,
        pageNum: this.page,
      }).then(res => {
        console.log(res, '11111')
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
        this.getNum()
      })
    },
    getNum() {
      queryWaitMeProcess({
        pageNum: this.page,
        pageSize: this.pageSize,
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.workNumber = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    add (type = 'new', id = '') {
      this.$refs.Application.showDetails(type, id, this.activeName)
    },
    add1 (type = 'new', id = '') {
      this.$refs.Application.showDetails(type, id, 'queryMine')
    },
    update (id = '') {
      this.$refs.Application.showDetails('new', id, 'queryMine')
    },
    async exportDetails (item) {
      this.downloadLoading = true
      await update({ printTimes: item.printTimes + 1, id: item.id })
      await this.getData()
      this.$refs.Download.getDetails(item.id, () => {
        this.downloadLoading = false
      })
    },
    async approval(id = '') {
      this.$confirm('此操作将进行催批, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': id
        }
        let res = await sendSmsAuditPersonAgain(params)
        if (res.code === 0) {
          this.$message({ type: 'success', message: '催批成功!' })
        }
        await this.getData()
      })
    },
  },
  mounted () {
    this.query()
  }
}
</script>
<style>
.export-row{
  /* background-color: #bddfff !important; */
}
</style>
